import { forwardRef } from 'react';
import type { IconButtonProps } from '@mui/material';
import { DeleteIcon } from '@src/shared/ui/icons';
import IconButton from './IconButton';

const DeleteIconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  (props, ref) => {
    return (
      <IconButton ref={ref} {...props}>
        <DeleteIcon color="inherit" />
      </IconButton>
    );
  },
);

DeleteIconButton.displayName = 'DeleteIconButton';
export default DeleteIconButton;
